export const ServiceWorkerMessages = {
  START_OFFLINE_DOWNLOAD: 'START_OFFLINE_DOWNLOAD',
  OFFLINE_DOWNLOAD_PROGRESS: 'OFFLINE_DOWNLOAD_PROGRESS',
  OFFLINE_DOWNLOAD_COMPLETE: 'OFFLINE_DOWNLOAD_COMPLETE',
  CHECK_OFFLINE_READY: 'CHECK_OFFLINE_READY',
  CAPTURE_POSTHOG_EVENT: 'CAPTURE_POSTHOG_EVENT',
  UPDATE_MAP_CACHE: 'UPDATE_MAP_CACHE',
  PUSH_NAVIGATE: 'PUSH_NAVIGATE',
  GET_CLIENT_URL: 'GET_CLIENT_URL',
  CACHE_DYNAMIC_ROUTES: 'CACHE_DYNAMIC_ROUTES',
  CLEAR_PERSONAL_CACHES: 'CLEAR_PERSONAL_CACHES',
} as const;
